'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('./../../components');

var _LeftViewApp = require('./LeftViewApp.scss');

var _LeftViewApp2 = _interopRequireDefault(_LeftViewApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logo = require('../../../res/images/logo/stingray.svg');

var LeftViewApp = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LeftViewApp, _Component);

  function LeftViewApp() {
    (0, _classCallCheck3.default)(this, LeftViewApp);
    return (0, _possibleConstructorReturn3.default)(this, (LeftViewApp.__proto__ || (0, _getPrototypeOf2.default)(LeftViewApp)).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftViewApp, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: _LeftViewApp2.default.content },
        _react2.default.createElement('div', { className: _LeftViewApp2.default.appBackground }),
        _react2.default.createElement(
          'div',
          { className: _LeftViewApp2.default.app },
          _react2.default.createElement(_components.LanguageDropdown, null),
          _react2.default.createElement(_components.HelpButton, null),
          _react2.default.createElement(
            'div',
            { className: _LeftViewApp2.default.logo },
            _react2.default.createElement('img', { src: logo })
          ),
          _react2.default.createElement(
            'div',
            { className: _LeftViewApp2.default.appContent },
            this.props.children
          )
        )
      );
    }
  }]);
  return LeftViewApp;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object.isRequired
}, _temp);
exports.default = LeftViewApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LeftViewApp/LeftViewApp.js
// module id = 1957
// module chunks = 0